<div class="container-row">
  <div class="container">
    @if ((lunaClaimValues.ManageLawLibrary | systemPermission) && activeNavItem && activeNavItem.id) {
      <div class="action-bar">
        <ng-container>
          <button role="button" attr.aria-label="Edit Law: {{activeNavItem.name}}" (click)="editLaw(activeNavItem.id)" [ngClass]="{'active': isEditingLaw}"><svg-icon title="Edit" icon="icon-page-edit" class="dark-gray pointer" aria-hidden="true"></svg-icon></button>
          <button role="button" attr.aria-label="Delete Law: {{activeNavItem.name}}" (click)="deleteFile()"><svg-icon title="Delete" icon="icon-trash" class="dark-gray pointer" aria-hidden="true"></svg-icon></button>
        </ng-container>
      </div>
    }
    @if (!activeNavItem) {
      <h3 class="h4 bold">No document selected!</h3>
      <p>Please select a law from the list on the left. If you are on a mobile device, select the tab to view the law library list.</p>
    }
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
